import React from 'react';
import PropTypes from 'prop-types';

import { CardRow } from '../InfoCard';

const propTypes = {
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
  postcode: PropTypes.string.isRequired,
};

const Description = ({ firstName, lastName, postcode }) => (
  <CardRow>
    <span>
      {firstName} {lastName}
    </span>
    <span>{postcode}</span>
  </CardRow>
);

Description.propTypes = propTypes;

export default Description;
